<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-model='theBusinessId' @change="theBusinessAllChange" size="small" clearable placeholder="请选择业务">
            <el-option
                v-for="item in getProjectBusiness_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addCustomBusinessModel"
          @click=" $form('addCustomBusinessModel'),getProjectBusiness({projectId:theProjectId}) "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加客户业务信息
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getCustomBusinessModelList'
      api='getCustomBusinessModelList'
      updateapi='updateCustomBusinessModel'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addCustomBusinessModel:    [ "新增客户业务信息信息", "el-icon-circle-plus" ],
        updateCustomBusinessModel: [ "修改客户业务信息信息", "el-icon-edit-outline"],
        $succeed$: getCustomBusinessModelList
      }'
      @close='$form("addCustomBusinessModel","reset")' >
      <hide slot='cbmId' />
      <template v-slot:businessId="{Myformdata}" >
        <el-select v-model='Myformdata.businessId' clearable>
            <el-option
                v-for="item in getProjectBusiness_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: "",
      theBusinessId: "",

      tableColums_getCustomBusinessModelList: {
        $selection: false,

        cbmKey: '属性key',

        cbmLabel: '属性名称',

        cbmOrder: '排序',

        $operation: [
          '操作', 200,
          this.updateCustomBusinessModel && `@text: 编辑#success
           @click: $form("updateCustomBusinessModel",$row),getProjectBusiness({projectId:theProjectId})
          `,
          this.deleteCustomBusinessModel && `@text: 删除#danger
           @click: _confirm('确定要删除该客户业务信息吗?')
                   .trigger('deleteCustomBusinessModel',{cbmId:$row.cbmId})
                   .trigger('getCustomBusinessModelList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    theProjectAllChange(e){
        this.theProjectId=e;
        this.theBusinessId="";
        this.getProjectBusiness({projectId:this.theProjectId});
    },
    theBusinessAllChange(e){
        this.theBusinessId=e;
        this.getCustomBusinessModelList({businessId:this.theBusinessId});
    },
  },

  created() {
    this.getCustomBusinessModelList({businessId:this.theBusinessId});
    this.getProjectBusiness({projectId:this.theProjectId});
    this.getProjectList({pageSize:0});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/CustomModelManage.vue